import L from "leaflet"

export class DataFetcher {
  constructor(map) {
    this.map = map;
    this.lastFetchBoundsHunting = null;
    this.lastFetchBoundsPersonal = null;
    this.lastFetchBoundsSeen = null;
    this.lastFetchBoundsHuntingAreas = null;
  }

  async fetchHuntingData(amenityUrl) {
    const visibleBounds = this.map.getBounds();

    // Check if the bounds are still in the last fetched bounds
    if (!this.shouldRefetchHunting(visibleBounds)) { 
      return null; 
    }

    const fetchBounds = this.expandBounds(visibleBounds, 0.5); // 50% wider buffer
    this.lastFetchBoundsHunting = L.latLngBounds([fetchBounds.south, fetchBounds.west], [fetchBounds.north, fetchBounds.east]);

    return this.fetchData(amenityUrl, fetchBounds);
  }

  async fetchPersonalData(personalUrl) {
    const visibleBounds = this.map.getBounds();

    // Check if the bounds are still in the last fetched bounds
    if (!this.shouldRefetchPersonal(visibleBounds)) { 
      return null; 
    }

    const fetchBounds = this.expandBounds(visibleBounds, 0.5); // 50% wider buffer
    this.lastFetchBoundsPersonal = L.latLngBounds([fetchBounds.south, fetchBounds.west], [fetchBounds.north, fetchBounds.east]);

    return this.fetchData(personalUrl, fetchBounds);
  }

  async fetchSeenData(seenUrl) {
    const visibleBounds = this.map.getBounds();

    // Check if the bounds are still in the last fetched bounds
    if (!this.shouldRefetchSeen(visibleBounds)) { 
      return null; 
    }

    const fetchBounds = this.expandBounds(visibleBounds, 0.5); // 50% wider buffer
    this.lastFetchBoundsSeen = L.latLngBounds([fetchBounds.south, fetchBounds.west], [fetchBounds.north, fetchBounds.east]);

    return this.fetchData(seenUrl, fetchBounds);
  }

  async fetchHuntingAreasData(huntingAreasUrl) {
    const visibleBounds = this.map.getBounds();

    // Check if the bounds are still in the last fetched bounds
    if (!this.shouldRefetchHuntingAreas(visibleBounds)) { 
      return null; 
    }

    const fetchBounds = this.expandBounds(visibleBounds, 0.5); // 50% wider buffer
    this.lastFetchBoundsHuntingAreas = L.latLngBounds([fetchBounds.south, fetchBounds.west], [fetchBounds.north, fetchBounds.east]);

    return this.fetchData(huntingAreasUrl, fetchBounds);
  }

  async fetchData(url, bounds) {
    const requestUrl = new URL(url);
    requestUrl.searchParams.set("south", bounds.south);
    requestUrl.searchParams.set("west", bounds.west);
    requestUrl.searchParams.set("north", bounds.north);
    requestUrl.searchParams.set("east", bounds.east);
    
    try {
      const response = await fetch(requestUrl.toString(), {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttprequest',
          'X-CSRF-Token': document.head.querySelector('meta[name="csrf-token"]').getAttribute("content"),
        },
        credentials: 'same-origin',
      });
      
      const data = await response.text();
      return JSON.parse(data);
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  expandBounds(bounds, multiplier = 0.5) {
    const latDiff = bounds.getNorth() - bounds.getSouth();
    const lonDiff = bounds.getEast() - bounds.getWest();

    const extraLat = latDiff * multiplier;
    const extraLon = lonDiff * multiplier;

    return {
      south: bounds.getSouth() - extraLat,
      west: bounds.getWest() - extraLon,
      north: bounds.getNorth() + extraLat,
      east: bounds.getEast() + extraLon,
    };
  }

  shouldRefetchHunting(currentVisibleBounds) {
    return !this.lastFetchBoundsHunting || !this.lastFetchBoundsHunting.contains(currentVisibleBounds);
  }

  shouldRefetchPersonal(currentVisibleBounds) {
    return !this.lastFetchBoundsPersonal || !this.lastFetchBoundsPersonal.contains(currentVisibleBounds);
  }

  shouldRefetchSeen(currentVisibleBounds) {
    return !this.lastFetchBoundsSeen || !this.lastFetchBoundsSeen.contains(currentVisibleBounds);
  }

  shouldRefetchHuntingAreas(currentVisibleBounds) {
    return !this.lastFetchBoundsHuntingAreas || !this.lastFetchBoundsHuntingAreas.contains(currentVisibleBounds);
  }
}
